import { Typography } from '@mui/material'

const LabelComponent = ({ text, sx }) => {
  return (
    <Typography
      id="expedientes-label-component"
      variant="h3"
      sx={{ mb: 1, fontSize: '1rem', ml: 0, fontWeight: '500', ...sx }}
    >
      {text}
    </Typography>
  )
}

export default LabelComponent
